<template>
	<div class='page'>
        <Page
            :total="dataCount"
            show-sizer
            class='pagination'
            @on-page-size-change='sizeChange'
            @on-change="changePage"
            :page-size-opts="[10,20,50,100]"
            :page-size="pageSize"
            />
    </div>
</template>

<script>
/*
    dataCount:总的条数
*/
    export default{
        props:[
            'dataCount',            
        ],
        data(){
            return{
              pageSize:10,
            }
        },
        methods:{
            sizeChange(val){
                this.pageSize = val
                this.$emit('byPageSize',val)
                
            },
            changePage(val){
              this.$emit('byPageCurrent',val)                 
            }
        },
    }
</script>

<style scoped>
    .page{
    	margin-top:20px;
    	height:40px;
    	padding-left: 50px;
    }
    .pagination{
    	float:right;
    }
</style>
